module.exports = __webpack_public_path__ + "img/illus-product.5bf94d29.svg";